// @file get current user info
import window, { ww } from 'bits/global'

const currentUser = window.$currentUser || ww?.xstore?.state.user || ww?.vueStartingState?.user || { id: null }

export default currentUser
